import script from "./DocSign.vue?vue&type=script&setup=true&lang=js"
export * from "./DocSign.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__